export const AllowedApproveMessage = [
  'accountManager',
  'staffAdmin',
  'superAdmin',
  'subAdmin',
  'sales',
]

export const isAllowApproveMessage = (role: string) => {
  return AllowedApproveMessage.includes(role)
}
